import { IconProps } from "../../../types/style";

const PenSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 21 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='pen-square 1' clipPath='url(#clip0_423_2063)'>
          <path
            id='Vector'
            d='M16.3333 0H4.66667C2.36917 0 0.5 1.86917 0.5 4.16667V15.8333C0.5 18.1308 2.36917 20 4.66667 20H16.3333C18.6308 20 20.5 18.1308 20.5 15.8333V4.16667C20.5 1.86917 18.6308 0 16.3333 0ZM18.8333 15.8333C18.8333 17.2117 17.7117 18.3333 16.3333 18.3333H4.66667C3.28833 18.3333 2.16667 17.2117 2.16667 15.8333V4.16667C2.16667 2.78833 3.28833 1.66667 4.66667 1.66667H16.3333C17.7117 1.66667 18.8333 2.78833 18.8333 4.16667V15.8333ZM12.0658 5.31583L6.47667 10.905C5.8475 11.5342 5.5 12.3717 5.5 13.2617V14.5833C5.5 15.0442 5.87333 15.4167 6.33333 15.4167H7.655C8.545 15.4167 9.3825 15.07 10.0117 14.44L15.6008 8.85083C16.5758 7.87583 16.5758 6.29083 15.6008 5.31583C14.6558 4.37167 13.01 4.37167 12.0658 5.31583ZM8.83333 13.2617C8.5225 13.5717 8.09333 13.75 7.655 13.75H7.16667V13.2617C7.16667 12.8167 7.34 12.3983 7.655 12.0833L11.1967 8.54167L12.375 9.72L8.83333 13.2617ZM14.4225 7.6725L13.5533 8.54167L12.375 7.36333L13.2442 6.49417C13.5583 6.17833 14.1075 6.17833 14.4225 6.49417C14.7475 6.81917 14.7475 7.3475 14.4225 7.6725Z'
            fill={color}
          />
        </g>
        <defs>
          <clipPath id='clip0_423_2063'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(0.5)'
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default PenSVG;
